import dateFormat from "dateformat";

export default (app) => {

	app.config.globalProperties.dFormat = (date, mask, utc, gmt) => {
		if(date == null) return '';

		if( utc === true && typeof gmt === 'string' ) {
			let d = new Date( date );
			date = new Intl.DateTimeFormat('en-US', {
				year: 'numeric',
				month: 'numeric',
				day: 'numeric',
				hour: 'numeric',
				minute: 'numeric',
				second: 'numeric',
				hour12: false,
				timeZone: gmt
			}).format(d)

			utc = false
			gmt = false
		}

		if( ['diff_dates', 'diff_dates_reverse'].includes(mask) ) {
			const DateDiff = {
				inMinutes: function(d1, d2) {
					const t2 = d2.getTime();
					const t1 = d1.getTime();

					return Math.floor((t2-t1)/(1000*60));
				},

				inHours: function(d1, d2) {
					const t2 = d2.getTime();
					const t1 = d1.getTime();

					return Math.floor((t2-t1)/(3600*1000));
				},

				inDays: function(d1, d2) {
					const t2 = d2.getTime();
					const t1 = d1.getTime();

					return Math.floor((t2-t1)/(24*3600*1000));
				},

				inWeeks: function(d1, d2) {
					const t2 = d2.getTime();
					const t1 = d1.getTime();

					return parseInt((t2-t1)/(24*3600*1000*7));
				},

				inMonths: function(d1, d2) {
					const d1Y = d1.getFullYear();
					const d2Y = d2.getFullYear();
					const d1M = d1.getMonth();
					const d2M = d2.getMonth();

					return (d2M+12*d2Y)-(d1M+12*d1Y);
				},

				inYears: function(d1, d2) {
					return d2.getFullYear()-d1.getFullYear();
				}
			}

			const d1 = mask === 'diff_dates_reverse' ? new Date() : new Date(date);
			const d2 = mask === 'diff_dates_reverse' ? new Date(date) : new Date();

			// calculates seconds between
			const diffMs = (d2.getTime() - d1.getTime()) / (1000*60)

			if( diffMs < 1 ) {
				return 'just now'
			} else if( diffMs < 60 ) {
				const b = DateDiff.inMinutes(d1, d2)
				return b + ' minute' +( b < 2 ? '' : 's' )
			} else if( diffMs < 3600 ) {
				const b = DateDiff.inHours(d1, d2)
				return b + ' hour' +( b < 2 ? '' : 's' )
			} else if( diffMs < 24*3600 ) {
				const b = DateDiff.inDays(d1, d2)
				return b + ' day' +( b < 2 ? '' : 's' )
			} else if( diffMs < 24*3600*7 ) {
				const b = DateDiff.inWeeks(d1, d2)
				return b + ' week' +( b < 2 ? '' : 's' )
			} else if( diffMs < 24*3600*30 ) {
				const b = DateDiff.inMonths(d1, d2)
				return b + ' month' +( b < 2 ? '' : 's' )
			} else if( diffMs < 24*3600*365 ) {
				const b = DateDiff.inYears(d1, d2)
				return b + ' year' +( b < 2 ? '' : 's' )
			}
		}

		return dateFormat( date, mask, utc, gmt );
	};
}